/**
 * RestaurantsList actions
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import { utils } from '../../devUtils';
import { rootApiResponse, clearDefaultError } from '../HeaderContainer/actions';

import {
  DEFAULT_ACTION,
  FETCH_RESTURANTPAGE_SUCCESS,
  FETCH_RESTURANTLIST_SUCCESS,
  // FETCH_RESTURANTLIST,
  // FETCH_RESTURANTLIST_ERROR,
} from './constants';

// const defaultAction = () => ({ type: DEFAULT_ACTION });

// const fetchActionPage = (payload) => ({ type: FETCH_RESTURANTLIST, payload });
const successActionPage = (payload) => ({ type: FETCH_RESTURANTPAGE_SUCCESS, payload });
export const successActionList = (payload) => ({ type: FETCH_RESTURANTLIST_SUCCESS, payload });
// const errorAction = (payload) => ({ type: FETCH_RESTURANTLIST_ERROR, payload });
/**
 * @todo 1) move cuisines API to the onload function of the component
 *       2) GET_MERCHANT_LOCATIONS will have different {payload}
 */
export const fetchResturantPage = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    // const MERCHANT_PATH = payload.keyword ? endpoint.GET_SEARCH_MERCHANT : endpoint.GET_MERCHANT_FILTERS;
    const { locations } = await reqHandler.postHandler(api, endpoint.GET_MERCHANT_LOCATIONS, payload);
    const { merchant_data, search_data = {}, total_merchants } = await reqHandler.postHandler(api, endpoint.GET_MERCHANT_FILTERS, payload);
    const { cuisines } = await reqHandler.getHandler(api, endpoint.GET_RESTURANT_CUISINES);
    const { tags } = await reqHandler.getHandler(api, endpoint.GET_RESTURANT_TAGS);
    const setPayload = {
      merchant_data: {
        data: merchant_data && merchant_data.length ? merchant_data : search_data.merchants || [],
        totalRecords: total_merchants || search_data.total_merchants,
      },
      locations: locations && locations.length ? utils.sortStringLocations(locations) : [],
      cuisines: cuisines && cuisines.length ? utils.sortArrayStrings(cuisines) : [],
      collection: tags && tags.length ? utils.lodashFilter(tags, { type: 'collection' }) : [],
      deal: tags && tags.length ? utils.lodashFilter(tags, { type: 'deal' }) : [],
    };
    dispatch(successActionPage(setPayload));
  } catch (e) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, e)));
  }
};

/**
 * @todo need to creat @func GET_MERCHANT_FILTERS API in one async @func fetchResturantList and @func fetchResturantPage
 * @todo: need to fix the need of @func clearDefaultError
 * @param {object} payload
 */
export const fetchResturantList = (payload) => async (dispatch, getState, api) => {
  try {
    // const MERCHANT_PATH = payload.keyword ? endpoint.GET_SEARCH_MERCHANT : endpoint.GET_MERCHANT_FILTERS;
    const { merchant_data, total_merchants, search_data = {} } = await reqHandler.postHandler(api, endpoint.GET_MERCHANT_FILTERS, payload);
    const setPayload = {
      merchant_data: {
        // data: merchant_data && merchant_data.length ? merchant_data : [],
        data: merchant_data && merchant_data.length ? merchant_data : search_data.merchants || [],
        totalRecords: total_merchants,
      },
    };
    dispatch(successActionList(setPayload));
  } catch (e) {
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, e)));
  }
};



// WEBPACK FOOTER //
// client/containers/RestaurantsList/actions.js